<template>
  <span class="col-eidt" :class="{ 'col-eidt-tooltip': showOverflowTooltip }">
    <span v-if="!edit" class="edit-text" @click="show()">
      <span>{{ _content }}</span>
      <i class="el-icon-edit-outline" style="color: #409eff" />
    </span>
    <div
      v-else
      class="col-edit-form"
      :class="{ 'is-error': !isValid && !isFocus }"
    >
      <el-tooltip
        effect="light"
        :value="!isValid && !isFocus"
        :manual="true"
        placement="bottom-start"
      >
        <div slot="content" class="col-edit-message">
          <i class="el-icon-warning" style="margin-right: 6px"></i>{{ message }}
        </div>
        <el-input
          ref="input"
          v-model="value"
          clearable
          :disabled="loading"
          :maxlength="maxlength"
          @focus="isFocus = true"
          @blur="isFocus = false"
          @keyup.enter.native="submit"
        />
      </el-tooltip>
      <i v-show="loading" class="el-icon-loading"></i>
    </div>
  </span>
</template>
<script>
import Log from "@/utils/log";
import { isEmpt } from "@/utils/utils";
import { EMPT_TEXT } from "../common";
import dealValidate from "@/utils/validate";
import Schema from "async-validator";

const log = Log("edit-col");

/**
 * 可编辑单元格
 */
export default {
  name: "EditCol",
  props: {
    content: {
      type: String,
      required: true,
    },
    showOverflowTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
      default: 128,
    },
    /**
     * 使用async-validator进行校验,格式参考async-validator的校验格式
     */
    validate: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    /**
     * 是否必填
     */
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      edit: false,
      value: "",
      loading: false,
      isValid: true,
      message: "",
      isFocus: false,
    };
  },
  computed: {
    _content() {
      return isEmpt(this.content) ? EMPT_TEXT : this.content;
    },
  },
  beforeDestroy() {
    window.removeEventListener("click", this.hide, true);
  },
  methods: {
    validator() {
      return new Promise((resolve, reject) => {
        if (this.validate) {
          const descriptor = {
            field: dealValidate(this.validate, "input", "", this.required),
          };
          const validator = new Schema(descriptor);
          validator.validate({ field: this.value }, (errors) => {
            if (errors) {
              console.log(errors, "<===============");
              this.message = errors[0].message;
              this.isValid = false;
              return reject();
            }
            this.isValid = true;
            return resolve();
          });
        } else {
          return resolve();
        }
      });
    },
    show() {
      this.edit = true;
      this.value = this.content;
      this.$nextTick(function () {
        this.$refs.input.focus();
        window.addEventListener("click", this.hide, true);
      });
    },
    hide(event) {
      if (!this.$el.contains(event.srcElement)) {
        this.submit();
      }
    },
    submit() {
      const hide = () => {
        this.edit = false;
        this.value = "";
        window.removeEventListener("click", this.hide, true);
      };
      if (this.value !== this.content) {
        this.validator()
          .then(() => {
            this.loading = true;
            this.$emit("update", this.value, () => {
              this.loading = false;
              hide();
            });
          })
          .catch(() => {
            log.error("可编辑单元格校验不通过");
          });
      } else {
        hide();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$error-color: #f95f5b;
.col-eidt {
  width: 100%;
  display: inline-block;
  cursor: pointer;
  .edit-text {
    padding-right: 16px;
    margin-right: -16px;
    min-height: 23px;
    position: relative;
  }
  .el-icon-edit-outline {
    display: none;
    position: absolute;
    right: 0;
    bottom: 2px;
  }
  &:hover .el-icon-edit-outline {
    display: block;
  }

  .col-edit-form {
    position: relative;
    .el-icon-loading {
      position: absolute;
      right: 5px;
      top: 10px;
    }
    &.is-error {
      ::v-deep {
        input {
          border-color: $error-color !important;
        }
      }
    }
  }
}

.col-edit-message {
  color: $error-color;
  font-size: 12px;
}

.col-eidt-tooltip {
  .edit-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
    vertical-align: middle;
  }
  .el-icon-edit-outline {
    display: none;
    position: absolute;
    right: 0;
    bottom: 5px;
  }
}
</style>
